module.exports = __webpack_public_path__ + "media/images/logo-fb-simple-4686477571a1e18ccd30f5dd2302dcb7.svg";